<template>
    <div class="row  justify-content-center" :class="{disabled :disabled, mainClass}">
        <div class="col-12 col-md-10 col-lg-8 detail--tab__header" :class="wrapperClass">
            <div class="row">
                <a v-for="tab in tabs" :ref="tab.value" :key="tab.value"
                   :class="determineClass(tab)"
                   :disabled="tab.disabled || false"
                   class="detail--tab col" href="#" @click.prevent="handleClick(tab.value)">
                    <div class="text-center" @click="handleClick(tab.value)">
                        <h6 class="detail--tab__title" @click="handleClick(tab.value)">{{tab.title}}</h6>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false,
                required: false,
            },
            currentTab: {
                type: String,
                required: true,
            },
            tabs: {
                type: Array,
                required: true,
            },
            wrapperClass: {
                type: String,
                required: false,
            },
            mainClass: {
                type: String,
                required: false,
            },
            tabClass: {
                type: String,
                required: false,
            },
            tabActiveClass: {
                type: String,
                required: false,
            }
        },
        watch: {
            currentTab(newCurrentTab) {
                if (this.newTab === newCurrentTab) return;
            }
        },
        data() {
            return {
                inputs: this.input,
            }
        },
        methods: {
            handleClick(value) {
                this.$emit('onClick', value);
                this.newTab = value;
            },
            determineClass(tab) {
                return [
                    { 'active': tab.value === this.currentTab },
                    tab.value === this.currentTab && this.tabActiveClass ? this.tabActiveClass: '',
                    this.tabClass,
                ]
            }
        },
        mounted() {
        }
    }
</script>
<style>
</style>
